export const feelingsItems = [
  { labelKey: "feelings.angry", value: "ANGRY" },
  { labelKey: "feelings.sad", value: "SAD" },
  { labelKey: "feelings.happy", value: "HAPPY" },
  { labelKey: "feelings.thoughtful", value: "THOUGHTFUL" },
  { labelKey: "feelings.unknown", value: "UNKNOWN" },
];
